import classNames from 'classnames'
import {memo, Suspense, useCallback} from 'react'

import type {ProjectOrBuildTypeNode} from '../../../../types'
import {getProjectBuildTypeFilter, stringifyId} from '../../../../types'
import {ProjectBuildTypeSelect} from '../../../common/ProjectBuildTypeSelect/ProjectBuildTypeSelect'
import UserSelect from '../../../common/UserSelect/AllUserSelect'
import type {UserSelectSelectedItem} from '../../../common/UserSelect/UserSelect.types'
import {useChangesFilter} from '../../../packages/Changes/Changes.hooks'
import ChangesContentFilter from '../../../packages/Changes/ChangesContentFilter/ChangesContentFilter'

import styles from './ChangesPageFilter.css'

type Props = {
  className?: string
}

function ChangesPageFilter({className}: Props) {
  const {filterOptions, onChangeFilter} = useChangesFilter()

  const onChangeUserId = useCallback(
    (data: UserSelectSelectedItem) => onChangeFilter({userId: data?.userId ?? ''}),
    [onChangeFilter],
  )

  const onChangeProject = useCallback(
    (data: ProjectOrBuildTypeNode | null | undefined) => {
      if (data?.nodeType === 'project') {
        onChangeFilter({projectId: stringifyId(data?.id) || null})
      } else {
        onChangeFilter({projectId: null})
      }
    },
    [onChangeFilter],
  )

  if (filterOptions == null) {
    return null
  }

  return (
    <div className={className} data-test-changes-filter>
      <div className={styles.firstLine}>
        <Suspense>
          <UserSelect
            className={styles.filterControl}
            selected={filterOptions.userId}
            onChange={onChangeUserId}
          />
        </Suspense>
        <ProjectBuildTypeSelect
          className={classNames(styles.filterControl, styles.projectSelect)}
          allItemName="All projects"
          selected={getProjectBuildTypeFilter({projectId: filterOptions.projectId})}
          onSelect={onChangeProject}
          forceFetch={false}
          buildTypesSelectable={false}
          allItemSelectable
          buttonMode
          expandAll
        />
      </div>
      <div className={styles.secondLine}>
        <ChangesContentFilter
          className={styles.filterControl}
          revision={filterOptions.revision}
          comment={filterOptions.comment}
          path={filterOptions.path}
          onChangeFilter={onChangeFilter}
        />
      </div>
    </div>
  )
}

export default memo<Props>(ChangesPageFilter)
